import React, { lazy } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useTokenValidation from "../../hooks/useTokenValidation";
import { useVendor } from "../../hooks/useVendor";
import { useFaviconStore } from "../../store/useFaviconStore";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

// Lazy load non-critical components
const ErrorComponent = lazy(() => import("../ErrorComponent/ErrorComponent"));
const AllRoute = lazy(() => import("../router"));
const CookieConsent = lazy(
  () => import("../../components/CookieConsent/CookieConsent")
);

// ErrorBoundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent error={this.state.error} />;
    }
    return this.props.children;
  }
}

const App = () => {
  const isConsentGiven = localStorage.getItem("cookieConsent") === "true";
  const { isValidationComplete, authError } = useTokenValidation();
  const IMG_URL = process.env.REACT_APP_IMG_URL;

  const { data: vendor = [], isSuccess } = useVendor();
  const { favicon, setFavicon } = useFaviconStore();

  useEffect(() => {
    if (isSuccess && vendor) {
      setFavicon(vendor.company_favicon);
    }
  }, [isSuccess, setFavicon, vendor]);

  useEffect(() => {
    if (!isValidationComplete) {
      console.log("Validating session...");
    }
  }, [isValidationComplete]);

  if (authError) {
    console.log("Session expired or invalid.");
    localStorage.removeItem("auth-storage");
    window.location.href = "/login";
  }

  return (
    <ErrorBoundary>
      <Helmet>
        <link
          rel="icon"
          type="image/png"
          href={`${IMG_URL}/site-favicon/${favicon}`}
        />
      </Helmet>
      <main className="App" id="scrool">
        {!isConsentGiven && <CookieConsent />}
        <AllRoute />
        <ToastContainer />
      </main>
    </ErrorBoundary>
  );
};

export default App;
